import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Impressum from "@/views/Imprint.vue";
import Projekte from "@/views/Projekte.vue";
import ProjektSite from "@/views/ProjektSite.vue";
import FotoSites from "@/views/FotoSites.vue";
import FotoSection from "@/components/Home/FotoSection.vue";
import Team from "@/views/Team.vue";
import Offer from "@/components/Home/OfferSection.vue";
import FotoOffer from "@/views/Offer/FotoOffer.vue";
import FilmOffer from "@/views/Offer/FilmOffer.vue";
import NotFound from "@/views/NotFound.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/fotos/:galleryName",
    component: FotoSites
  },
  {
    path: "/fotos",
    component: FotoSection
  },
  {
    path: "/projekte",
    name: "Projekte",
    component: Projekte
  },
  {
    path: "/projekte/:filmName",
    component: ProjektSite
  },
  {
    path: "/team",
    name: "Team",
    component: Team
  },
  {
    path: "/angebot",
    name: "Offer",
    component: Offer
  },
  {
    path: "/angebot/foto",
    name: "FotoOffer",
    component: FotoOffer
  },
  {
    path: "/angebot/film",
    name: "FilmOffer",
    component: FilmOffer
  },
  {
    path: "/impressum",
    name: "Impressum",
    component: Impressum
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFound
  },{
    path: "/filme/:*",
    component: NotFound
  }
];

const router = new VueRouter({
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else {
      return { x: 0, y: 0 };
    }
  },

  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
